<template>
    <el-dialog title="代理商编辑" :visible.sync="dialogShow" @close="closeDialog" @open="openDialog">

        <el-form :model="form" :rules="rules" ref="form">

            <el-form-item label="代理商名称" :label-width="formLabelWidth" prop="loginName" >
                <el-input v-model="form.loginName" autocomplete="off" placeholder="请输入代理商登陆账号" :disabled="action ==='editAgent'"></el-input>
            </el-form-item>

            <el-form-item label="代收费率(%)" :label-width="formLabelWidth" prop="agentPayinRate">
                <el-input v-model="form.agentPayinRate" autocomplete="off" placeholder="请输入代收费率"></el-input>
            </el-form-item>
            <el-form-item label="代付费率(%)" :label-width="formLabelWidth" prop="agentPayoutRate">
                <el-input v-model="form.agentPayoutRate" autocomplete="off" placeholder="请输入代付费率"></el-input>
            </el-form-item>

            <el-form-item label="收银台页面" :label-width="formLabelWidth" prop="checkoutUrl">
                <el-input v-model="form.checkoutUrl" autocomplete="off" placeholder="请输入checkoutUrl"></el-input>
            </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="saveMerchant">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "SystemEdit",
        props: {
            show: Boolean,
            formData: Object,
            action: String,
        },

        created(){
        },
        data(){
            return {
                dialogShow: this.show,
                form: {
                    agentId:'',
                    loginName: '',
                    agentPayinRate:'',
                    agentPayoutRate:'',
                    logoUrl:'',
                    checkoutUrl:''
                },
                agentList:[],
                formLabelWidth: '120px',
                rules: {
                    agentPayinRate: [
                        {required: true, message: '请输入代收费率', trigger: 'blur'},
                        {min: 1, max: 10, message: '请输入1到2个数字', trigger: 'blur'}
                    ],
                    agentPayoutRate: [
                        {required: true, message: '请输入代付费率', trigger: 'blur'},
                        {min: 1, max: 10, message: '请输入1到2个数字', trigger: 'blur'}
                    ],
                    loginName:[
                        {required: true, message: '请输入代理商登陆账号', trigger: 'blur'},
                        {min: 6, max: 20, message: '请输入6到20个字母和数字', trigger: 'blur'}
                    ]
                }
            }
        },
        methods:{
            agentNameChange(){
            },
            openDialog() {
                if (this.formData != null) {
                    this.form.agentId = this.formData.agentId;
                    this.form.agentName = this.formData.agentName;
                    this.form.loginName = this.formData.loginName;
                    this.form.agentPayinRate = this.formData.agentPayinRate;
                    this.form.agentPayoutRate = this.formData.agentPayoutRate;
                    this.form.logoUrl = this.formData.logoUrl;
                    this.form.checkoutUrl = this.formData.checkoutUrl;
                }
            },
            closeDialog() {
                this.dialogShow = false;
                this.$refs['form'].resetFields(); //关闭的时候重置表单
                this.$emit('update:show', false);
            },

            saveMerchant(){

                if (this.action === "addAgent"){
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            this.axios.post("/agent/addAgent", this.form).then(res => {
                                if (res.code === 200) {

                                    this.$notify({
                                        title: '添加成功',
                                        message: res.msg,
                                        type: 'success'
                                    });

                                    this.$bus.$emit('refresh'); //通知刷新

                                    this.closeDialog();
                                } else {

                                    this.$notify.error({
                                        title: '添加失败',
                                        message: res.msg,
                                    });
                                }
                            })
                        } else {
                            return false;
                        }
                    });
                }

                if (this.action === "editAgent"){
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            this.axios.post("/agent/updateAgent", this.form).then(res => {
                                if (res.code === 200) {

                                    this.$notify({
                                        title: '更新成功',
                                        message: res.msg,
                                        type: 'success'
                                    });

                                    this.$bus.$emit('refresh'); //通知刷新

                                    this.closeDialog();
                                } else {

                                    this.$notify.error({
                                        title: '跟新失败',
                                        message: res.msg,
                                    });
                                }
                            })
                        } else {
                            return false;
                        }
                    });
                }
            }
        },
        watch: {
            show(newVal) {
                this.dialogShow = newVal;
            }
        },
    }
</script>

<style scoped>

</style>